
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeTaskEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiEsperienzeTaskRow> {
        protected getFormKey() { return ProdottiEsperienzeTaskForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeTaskRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeTaskRow.localTextPrefix; }

        protected form = new ProdottiEsperienzeTaskForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }
    }
}